import Modal from '@components/v2/ui/Modal/Modal';
import { memo } from 'react';
import LangEnum from '../../../../../../../../../../lang/LangEnum';
import { SelloutProductColor } from '../../../../../../../../../../services/modules/product-color-sellout/product-color-sellout.types';
import useSelloutModal from '../../../hooks/useSelloutModal';
import SelloutModalContent from './SelloutModalContent';

interface SelloutModalProps {
  isOpen: boolean;
  onClose: () => void;
  readMode: boolean;
  selloutData: SelloutProductColor;
}

const SelloutModal = ({ isOpen, onClose, readMode, selloutData }: SelloutModalProps) => {
  const { pieces, onChangePieces, disabled, distribution, handleApplyGrid } = useSelloutModal({
    onClose,
    readMode,
    selloutMetrics: selloutData,
  });

  return (
    <Modal
      isOpen={isOpen}
      size="expanded"
      header={{ title: LangEnum.GLOBAL_RETAIL }}
      onClose={onClose}
      footer={{
        primaryAction: {
          label: LangEnum.GLOBAL_APPLY_GRID,
          isDisabled: disabled,
          tooltipMessage: disabled
            ? LangEnum.PRODUCT_SELLOUT_UNAVAILABLE_TO_APPLY_DISTRIBUTION
            : undefined,
          onClick: handleApplyGrid,
        },
        secondaryAction: { label: LangEnum.GLOBAL_CANCEL_LABEL, onClick: onClose },
      }}
    >
      <SelloutModalContent
        pieces={pieces}
        disabled={disabled}
        distribution={distribution}
        selloutProductColor={selloutData}
        onChangePieces={onChangePieces}
      />
    </Modal>
  );
};

export default memo(SelloutModal);
